import { render } from "./VerRoles.vue?vue&type=template&id=2704e4bc"
import script from "./VerRoles.vue?vue&type=script&lang=js"
export * from "./VerRoles.vue?vue&type=script&lang=js"

import "./VerRoles.vue?vue&type=style&index=0&id=2704e4bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__